import { render, staticRenderFns } from "./DishInformation.vue?vue&type=template&id=d5b12900&scoped=true&"
import script from "./DishInformation.vue?vue&type=script&lang=js&"
export * from "./DishInformation.vue?vue&type=script&lang=js&"
import style0 from "./DishInformation.vue?vue&type=style&index=0&id=d5b12900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b12900",
  null
  
)

export default component.exports